(function () {
  'use strict';

  if (window.__technicalDetailsTooltipInstance) return;

  class TechnicalDetailsTooltip {
    constructor() {
      this.tooltip = null;
      this.currentElement = null;
      this.hideTimeout = null;
      this.boundMouseEnter = this.handleMouseEnter.bind(this);
      this.boundMouseLeave = this.handleMouseLeave.bind(this);
      this.boundMouseMove = this.handleMouseMove.bind(this);
      this.init();
    }

    init() {
      this.tooltip = document.createElement('div');
      this.tooltip.className = 'technical-details-tooltip-popup';
      this.tooltip.setAttribute('role', 'tooltip');
      this.tooltip.setAttribute('aria-hidden', 'true');
      document.body.appendChild(this.tooltip);

      document.addEventListener('mouseenter', this.boundMouseEnter, true);
      document.addEventListener('mouseleave', this.boundMouseLeave, true);
      document.addEventListener('mousemove', this.boundMouseMove, true);

      this.tooltip.addEventListener('mouseenter', () => {
        if (this.hideTimeout) {
          clearTimeout(this.hideTimeout);
          this.hideTimeout = null;
        }
      });

      this.tooltip.addEventListener('mouseleave', () => {
        this.hideTooltip();
      });
    }

    handleMouseEnter(e) {
      const target = e.target;
      if (!(target instanceof Element)) return;

      const trigger = target.closest('[data-tooltip-content]');
      if (!trigger) {
        if (target === this.tooltip || this.tooltip.contains(target)) {
          return;
        }
        return;
      }

      this.currentElement = trigger;
      this.showTooltip(trigger);
    }

    handleMouseLeave(e) {
      const target = e.target;
      if (!(target instanceof Element)) return;

      const trigger = target.closest('[data-tooltip-content]');
      const relatedTarget = e.relatedTarget;

      if (trigger && trigger === this.currentElement) {
        if (relatedTarget && (relatedTarget === this.tooltip || this.tooltip.contains(relatedTarget))) {
          return;
        }
        this.hideTimeout = setTimeout(() => {
          if (!this.tooltip.matches(':hover') && !this.tooltip.contains(document.activeElement)) {
            this.hideTooltip();
          }
        }, 100);
        return;
      }

      if (relatedTarget && !this.tooltip.contains(relatedTarget) && relatedTarget !== this.currentElement) {
        this.hideTooltip();
      }
    }

    handleMouseMove(e) {
      if (!this.currentElement || !this.tooltip.classList.contains('visible')) return;

      const x = e.clientX;
      const y = e.clientY;
      const tooltipRect = this.tooltip.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const viewportWidth = window.innerWidth;

      let left = x + 15;
      let top = y + 15;

      if (left + tooltipRect.width > viewportWidth) {
        left = x - tooltipRect.width - 15;
      }
      if (left < 10) {
        left = 10;
      }

      if (top + tooltipRect.height > viewportHeight) {
        top = y - tooltipRect.height - 15;
      }
      if (top < 10) {
        top = 10;
      }

      this.tooltip.style.left = `${left}px`;
      this.tooltip.style.top = `${top}px`;
    }

    showTooltip(trigger) {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }

      const tooltipHtml = trigger.getAttribute('data-tooltip-html');
      const tooltipText = trigger.getAttribute('data-tooltip-text');

      if (!tooltipHtml && !tooltipText) return;

      if (tooltipHtml) {
        this.tooltip.innerHTML = this.decodeHtml(tooltipHtml);
      } else {
        this.tooltip.textContent = tooltipText;
      }

      this.tooltip.classList.add('visible');
      this.tooltip.setAttribute('aria-hidden', 'false');

      const rect = trigger.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const tooltipWidth = 320;

      let left = rect.right + 15;
      if (left + tooltipWidth > viewportWidth) {
        left = rect.left - tooltipWidth - 15;
      }

      this.tooltip.style.left = `${left}px`;
      this.tooltip.style.top = `${rect.top - 10}px`;
    }

    hideTooltip() {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
      this.tooltip.classList.remove('visible');
      this.tooltip.setAttribute('aria-hidden', 'true');
      this.currentElement = null;
      this.tooltip.innerHTML = '';
    }

    decodeHtml(html) {
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    }
  }

  function hasTriggers() {
    return document.querySelector('[data-tooltip-content]');
  }

  function boot() {
    if (window.__technicalDetailsTooltipInstance) return;
    window.__technicalDetailsTooltipInstance = new TechnicalDetailsTooltip();
    document.removeEventListener('mouseenter', onLazyBoot, true);
  }

  function onLazyBoot(e) {
    if (!(e.target instanceof Element)) return;
    if (!e.target.closest('[data-tooltip-content]')) return;
    boot();
  }

  function tryBoot() {
    if (hasTriggers()) boot();
  }

  document.addEventListener('mouseenter', onLazyBoot, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryBoot);
  } else {
    tryBoot();
  }
})();
